import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEDemographicsCardActions = {
  initPeDemographicsCard: ({ commit }) => {
    commit('setPeDemographicsCardLock', true)
  },
  peDemographicsCardRefresh: async ({ commit, getters }, { id }) => {
    return axiosRequest.
      get(`/parties/${id}/show_selected`, {
        params: {
          selected: [
            'yearly_household_income_range',
            'household_size',
            'race',
            'religion',
            'ethnicity',
          ],
        },
      }).
      then(({ data }) => {
        commit('setPeDemographicsCardLock', true)
        commit('pePatchParty', {
          yearly_household_income_range: data.yearly_household_income_range,
          household_size: data.household_size,
          race: data.race,
          religion: data.religion,
          ethnicity: data.ethnicity,
        })
      }).
      catch(handleError)
  },
  peDemographicsCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        yearly_household_income_range: section.yearly_household_income_range,
        household_size: section.household_size,
        race: section.race,
        religion: section.religion,
        ethnicity: section.ethnicity,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeDemographicsCardLock', true)
        commit('pePatchParty', {
          yearly_household_income_range: updatedParty.yearly_household_income_range,
          household_size: updatedParty.household_size,
          race: updatedParty.race,
          religion: updatedParty.religion,
          ethnicity: updatedParty.ethnicity,
        })
      }).
      catch(handleError)
  },
}

export const PEDemographicsCardMutations = {
  setPeDemographicsCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'DemographicsCard', lock)
  },
}

export const PEDemographicsCardGetters = {
  PeDemographicsCardLock: state => state.partyEdit.partySections.DemographicsCard,
}
